module.exports = "<footer class=\"app-footer\">\r\n  <a href=\"http://www.prodfor.com.br\">PRODFOR</a> &copy; {{ currentYear }} - Programa Integrado de Desenvolvimento e Qualificação de Fornecedores.\r\n  <span class=\"float-right\">Desenvolvido por <a href=\"http://www.formalis.com.br\">Formalis Informatica LTDA</a></span>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main